import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import { env, isProd } from '@/config/host';
import { ClientUtil } from '@xl/js-utils';
import { Dialog } from 'vant';
import sensors from '@/common/sensors';
import ua from '@xl/user-agent';
const { is_xl_driver_app } = ua.parse();

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;

// issue 处理
// https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378
// https://github.com/hsingyin/hsingyin.site/issues/7#issue-586782745
VueRouter.prototype.push = function push(location: string) {
  return (originalPush.call(this, location) as any).catch(
    (error: Error) => error,
  );
};

const router = new VueRouter({
  mode: 'history',
  base: isProd ? '/join/' : '/',
  routes,
});

// 导航守卫
router.afterEach((route) => {
  const { title, style } = route.meta;

  if (
    window.$pageSpy &&
    typeof window.$pageSpy.updateRoomInfo === 'function' &&
    !isProd
  ) {
    window.$pageSpy.updateRoomInfo({
      title: `${title || '司机准入'}(${env.toLocaleUpperCase()})`,
      project: '司机准入',
    });
  }

  if (title) {
    document.title = title;
    const routeMap: Record<string, string> = {
      FaceRecognition:
        '完成人脸识别即可完成资料提交，审核通过即可接单，确认退出吗？',
    };
    const routeTrackMap: Record<string, string> = {
      FaceRecognition: '人脸识别页',
    };
    // app内，设置app标题栏， 一定要延时，不然ios返回会显示加载中
    if (process.env.NODE_ENV !== 'development') {
      if (is_xl_driver_app && ClientUtil.getAppClientVersion() >= 1036) {
        if (!style) {
          setTimeout(() => {
            ClientUtil.webcall({
              action: 'setTitle',
              title,
            });
          }, 0);
        } else {
          ClientUtil.webcall(
            {
              action: 'toolbar_control',
              msg: title,
              style: style, // navigation or home
              toolBarIconIsShow: title === '小拉出行',
            },
            () => {
              const msg = routeMap[route.name || ''];
              if (msg) {
                /**
                 * @log register_restrain_popup_expo
                 * @name register_restrain_popup_expo
                 * @description 司机注册_二次挽留_弹窗曝光
                 * @route ['/faceRecognition']
                 * @param page_name - [object Object]
                 */
                sensors.track('register_restrain_popup_expo', {
                  page_name: routeTrackMap[route.name || ''],
                });

                Dialog.confirm({
                  title: '退出认证',
                  message: msg,
                  confirmButtonText: '继续认证',
                  cancelButtonText: '确认离开',
                })
                  .then(() => {
                    /**
                     * @log register_restrain_popup_click
                     * @name register_restrain_popup_click
                     * @description 司机注册_二次挽留_弹窗点击
                     * @route ['/faceRecognition']
                     * @param page_name - [object Object]
                     * @param module_name - 继续认证
                     */
                    sensors.track('register_restrain_popup_click', {
                      page_name: routeTrackMap[route.name || ''],
                      module_name: '继续认证',
                    });
                  })
                  .catch(() => {
                    /**
                     * @log register_restrain_popup_click
                     * @name register_restrain_popup_click
                     * @description 司机注册_二次挽留_弹窗点击
                     * @route ['/faceRecognition']
                     * @param page_name - [object Object]
                     * @param module_name - 确认离开
                     */
                    sensors.track('register_restrain_popup_click', {
                      page_name: routeTrackMap[route.name || ''],
                      module_name: '确认离开',
                    });

                    router.replace({
                      path: '/successReg',
                      query: {
                        driver_id: route.query.driver_id,
                      },
                    });
                  });
                return;
              }

              router.replace({
                path: '/successReg',
                query: {
                  driver_id: route.query.driver_id,
                },
              });
            },
          );
        }
      } else {
        // 之前版本
        setTimeout(() => {
          ClientUtil.webcall({
            action: 'setTitle',
            title,
          });
        }, 0);
      }
    }
  }
});

export default router;
